/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateOrganizationPaymentPlanFreeResponseDataFromJSON, UpdateOrganizationPaymentPlanFreeResponseDataToJSON } from './UpdateOrganizationPaymentPlanFreeResponseData';
export function UpdateOrganizationPaymentPlanFreeResponseFromJSON(json) {
    return UpdateOrganizationPaymentPlanFreeResponseFromJSONTyped(json, false);
}
export function UpdateOrganizationPaymentPlanFreeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: UpdateOrganizationPaymentPlanFreeResponseDataFromJSON(json['data'])
    };
}
export function UpdateOrganizationPaymentPlanFreeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: UpdateOrganizationPaymentPlanFreeResponseDataToJSON(value.data)
    };
}
